const ROUTING_KEY_COOKIE = "sd-routing-key";

export const getRoutingKeyFromCookie = (): string | undefined => {
  for (const entry of document.cookie.split(";")) {
    const [rawName, ...rawValue] = entry.split("=");
    if (rawName!.trim() !== ROUTING_KEY_COOKIE) continue;
    return rawValue.join("=").trim() || undefined;
  }
  return undefined;
};

export const buildSharableSandboxLink = (routingKey: string): string => {
  const redirect = encodeURIComponent(window.location.pathname + window.location.search || "");
  return `${window.location.origin}/remocal/connect/${routingKey}?redirect=${redirect}`;
};
